import { IHttpInterceptor, IPromise, IHttpResponse, IHttpService, IRequestConfig, ITimeoutService, ILogService } from "angular";
import { $InjectorLike } from "angular-ui-router";
import { HttpInterceptorFactory } from "./http-interceptor.factory";

const httpServiceUnavailable = 503;
const maxRetries = 3;
const retryIntervalMs = 20000;

interface RetryRequestConfig extends IRequestConfig {
    tryCount: number;
    maxRetries: number;
}

/**
 * An HTTP interceptor that retries HTTP requests that return 503 Service Unavailable.
 */
export class RetryServiceUnavailableInterceptor implements IHttpInterceptor {
    constructor(private $injector: $InjectorLike, private $log: ILogService) {
        'ngInject';
    }
    responseError<T>(response: any): IPromise<IHttpResponse<T>> | IHttpResponse<T> {
        if (response.status !== httpServiceUnavailable || !response.config) {
            // Rethrow to continue with next interceptor.
            throw response;
        }
        const retryConfig = { ...response.config } as RetryRequestConfig;
        if (retryConfig.tryCount === undefined) {
            retryConfig.tryCount = 1;
            retryConfig.maxRetries = maxRetries;
        } else {
            retryConfig.tryCount++;
        }
        if (retryConfig.tryCount >= retryConfig.maxRetries) {
            this.$log.warn("HTTP 503: request exceeded the maximum number of retries", retryConfig)
            throw response;
        }
        this.$log.info(`HTTP 503: service was unavailable. Attempt ${retryConfig.tryCount}/` +
            `${retryConfig.maxRetries} failed.`, retryConfig);
        const $http = this.$injector.get<IHttpService>("$http");
        const $timeout = this.$injector.get<ITimeoutService>("$timeout");

        return $timeout(() => {
            return $http<T>(retryConfig);
        }, retryIntervalMs);
    }
}

export const retryServiceUnavailableInterceptorFactory = HttpInterceptorFactory(RetryServiceUnavailableInterceptor);
